<template>
    <div class="container">
        <header class="jumbotron">
            <h3>
                Profil użytkownika
            </h3>
        </header>
        <p>
            <strong>Login:</strong>
            {{currentUser.userName}}
        </p>
        <p>
            <strong>Imię:</strong>
            {{currentUser.firstName}}
        </p>
        <p>
            <strong>Nazwisko:</strong>
            {{currentUser.lastName}}
        </p>
        <ul>
            <li v-for="role in currentUser.roles" :key="role">{{role}}</li>
        </ul>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label for="password"><strong>Nowe hasło:</strong> </label>
                <InputText id="password" type="password" v-model="content.password" placeholder="Hasło"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label for="passwordConfirm"><strong>Powtórz hasło:</strong> </label>
                <InputText id="zipCode" type="password" v-model="content.passwordConfirm" placeholder="Powtórz hasło"/>
            </div>
            <div class="p-field p-col-12 p-md-6 fa-pull-right">
                <Button type="button" label="Zmień hasło" v-on:click="click"/>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "../services/user.service";

    export default {
        inject: ['global'],
        name: 'Profile',
        props: {
            initialCntent: {
                // eslint-disable-next-line vue/require-valid-default-prop
                password: 'null',
                passwordConfirm: 'null'
            }
        },
        data() {
            return {
                content: {
                    password: null,
                    passwordConfirm: null
                },
                currentUser: this.$store.state.auth.user
            };
        },
        methods: {
            click: function () {
                UserService.chongePassword(this.content, this.$route.params.roleId).then(
                    () => {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Sukces',
                            detail: 'Zmieniono hasło',
                            life: 3000
                        });
                    },
                    (error) => {
                        this.$toast.add({
                            severity: 'error',
                            summary: error.response.data.error,
                            detail: error.response.data.message,
                            life: 3000
                        });
                    }
                );
            },
            goBack: function () {
                this.$router.push({path: `${this.global.state.instancePatch}/role/lista`});
            },
            parseJwt(token) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                return JSON.parse(jsonPayload);
            }
        },
        mounted() {
            this.currentUser = this.parseJwt(this.currentUser.accessToken);
            if (!this.currentUser) {
                this.$router.push(`${this.global.state.instancePatch}/login`);
            }
        }
    };
</script>
